module.exports =
  '_GROUP_TIMELINE':
    'TITLE': 'Timeline'
    'CREATE_EVENT_TITLE': '{{name}} created Event {{event}}'
    'UPDATE_EVENT_TITLE': '{{name}} updated Event {{event}}'
    'DELETE_EVENT_TITLE': '{{name}} deleted Event {{event}}'
    'SUBMIT_SCORE_TITLE': '{{name}} submitted a score to {{event}}'
    'SUBMIT_SCORES_TITLE': '{{name}} submitted {{score_cards_count}} scores to {{event}}'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-timeline/i18n/en.coffee